import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoSeConfig } from './presets/contact-axo-se.config';
import { globalSe } from './presets/global-se.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationAxoSeConfig } from './presets/organisation-axo-se.config';
import { serviceTrustpilotAxoSeConfig } from './presets/service-trustpilot-axo-se.config';
import { serviceVwoUscoreConfig } from './presets/service-vwo-uscore.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansSeConfig } from './presets/unsecured-loans-se.config';

export const global: GlobalConfig = {
  brand: 'uscore.se',
  ...globalSe,
};

export const site: SiteConfig = {
  domain: 'uscore.se',
  name: 'uScore',
  theme: {
    name: 'uscore-light',
    brand: 'uscore',
  },
  path: {
    loansApply: '/loans/apply',
    mypage: 'https://mypage.axofinans.se',
  },
  ...organisationAxoSeConfig,
  ...contactAxoSeConfig,
  services: {
    cms: {
      accessToken: {
        production:
          'ac_fb223f1c6f08e1c6655233de4bf1ec13774f7bd314ae8c8d47c3868b85f5a356',
        preview:
          'ac_eb2f39f39aa4032c0b260269dd8291425d355232b946bb033eb47f85954b32cf',
      },
    },
    trustpilot: serviceTrustpilotAxoSeConfig,
    gtm: 'GTM-MMJ8P92Z',
    ga: 'G-598Y2XNJF6',
    gtmScriptStrategy: 'lazyOnload',
    usercentrics: {
      settingsId: 'LiOjrjIgM8FG8A',
      crossDomainBridgeScriptStrategy: 'lazyOnload',
      autoBlockerScriptStrategy: 'lazyOnload',
      usercentricsScriptStrategy: 'lazyOnload',
    },
    ...serviceVwoUscoreConfig,
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansSeConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: { hasHighCostWarning: false, ...myPageOffersConfig },
};
